// extracted by mini-css-extract-plugin
export default {"footerBg":"ja-z","footerTopLinks":"ka-z","footerFeedback":"la-z","footerSocial":"ma-z","footerLegalLinks":"na-z","footerIconCards":"oa-z","footerBotCopy":"pa-z"};